export default __webpack_public_path__ + "static/media/Move.37d0c14f.mp3";